
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import moment from 'moment';
    import {
        PatientStatistikOptions,
        PatientStatistikPayload
    } from '@/store/statistik';
    import { VMenu } from '@/types/Components';

    @Component({
        computed: {
            ...mapState('statistik', ['loaders']),
        },
        methods: {
            ...mapActions('statistik', ['printPatientenstatistik', 'exportPatientenstatistikExcel']),
        },
    })
    export default class Patientenmitimpfung extends Vue {
        @Prop() public visible!: boolean;

        public $refs!: {
            zeitraumMenu: VMenu;
        };

        public printPatientenstatistik!: (payload: { options: PatientStatistikPayload }) => void;
        public exportPatientenstatistikExcel!: (payload: { options: PatientStatistikPayload }) => void;
        public zeitraumMenu = false;
        public zeitraumErrorMessages: string[] = [];

        public options: PatientStatistikOptions = {
            zeitraum: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD'),
            ],
        };

        public get maxZeitraum(): string {
            return moment().format('YYYY-MM-DD');
        }

        public get zeitraumLabel(): string {
            return this.options.zeitraum.length
                ? 'von ' + this.options.zeitraum.sort((a, b) => a.localeCompare(b)).map((date) => {
                    const [year, month, day] = date.split('-');
                    return `${day}.${month}.${year}`;
                }).join(' bis ')
                : '';
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.zeitraumErrorMessages = [];
            }
        }

        @Watch('zeitraum')
        public onChangeZeitraum(dates: [string, string]): void {
            if (dates?.length === 2) {
                this.options.zeitraum = dates;
            }
        }

        public saveZeitraum(date: [string, string]): void {
            this.options.zeitraum = date;
            this.$refs.zeitraumMenu.save(date);

            this.zeitraumErrorMessages = [];

            const [von, bis] = this.options.zeitraum;
            if (Math.abs(moment(von).diff(moment(bis), 'days')) > 365) {
                this.zeitraumErrorMessages.push('Zeitraum darf nicht mehr als 365 Tage überschreiten.');
            }
        }

        public onClickPrint(): void {
            const options: PatientStatistikPayload = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };


            this.printPatientenstatistik({ options });
        }

        public onClickExport(): void {
            const options: PatientStatistikPayload = {
                ...this.options,
                zeitraum: this.options.zeitraum.sort((a, b) => a.localeCompare(b)),
            };


            this.exportPatientenstatistikExcel({ options });
        }
    }
